import { usePreviousValue } from '../../hooks/usePrevious'

export default function (index) {
  const previousIndex = usePreviousValue(index)
  return index >= 0 ? index : previousIndex
}
